
import './main.css'

import { useEffect, useState } from 'react';
import { RightOutlined, VideoCameraOutlined, ExclamationCircleOutlined, SettingOutlined, CrownOutlined, MessageOutlined, FireOutlined, CommentOutlined, LinkOutlined, YoutubeOutlined, PlusCircleOutlined, ReloadOutlined, ProfileOutlined, UserSwitchOutlined, CheckCircleFilled, CheckCircleTwoTone, DollarOutlined, ShopOutlined, DashOutlined, DashboardOutlined, BarChartOutlined, MailOutlined, GlobalOutlined } from '@ant-design/icons';
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Popover, Radio, Button, Modal, Input, Space, message, Carousel, Tabs, Collapse, Tooltip, Divider, Slider, Select, Tag, Alert, Steps, Checkbox } from 'antd';
import logo from '../../images/logo.png'
import callAPI from '../fetch/main';
import ShowPlans from "../../comps/show_plans/main";
import confetti from 'canvas-confetti';



function Sider(props) {
  const { TextArea } = Input;
  const [open, setOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [feedbacktext, setFeedbackText] = useState('')

  const [showReconnect, setShowReconnect] = useState()

  const [showSettings, setShowSettings] = useState()

  const [settingsPayload, setSettingsPayload] = useState()
  const [loading, setLoading] = useState()

  const [initialSettingPayload, setInitalSettingPayload] = useState()
  const [settingsApiUpdate, setSettingsApiUpdated] = useState()
  const [updateLoading, setupdateLoading] = useState()

  const [showCreateAccount, setShowCreateAccount] = useState()

  const token = localStorage.getItem("token")
  

  const location = useLocation();

  const [showPlanModal, setShowPlanModal] = useState(props?.showPlan || false)

  const [decodedToken, setDecodeToken] = useState()

  const localStoreConnectedAccount = JSON.parse(localStorage.getItem("connected_accounts"))

  const [connectedAccounts, setConnectedAccounts] = useState(localStoreConnectedAccount)
  const [connectedAccountsLoading, setConnectedAccountsLoading] = useState(localStoreConnectedAccount)
  

  const [createLinkedAccount, setCreateLinkedAccount] = useState()
  const [createLinkedAccountLoding, setCreateLinkedAccountLoading] = useState()
  const [linkAccountData, setLinkAccountData] = useState({})


  const [accountType, setAccountType] = useState("creator")

  let default_img = "https://public-assets.instantdm.com/instandm/pro_pic/empty/pro-pic.png";
  
  let plan_limit = {"428338": {"max_rate" : 1500} , "428337":{"max_rate" : 1500} , "000003":{"max_rate" : 800} , "0000031":{"max_rate" : 800} }

  const SliderFormat = (value) => {
    if (value < 60) {
      return `${value} Mins`;
    } else {
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      return `${hours} Hr ${minutes} Mins`;
    }
  }

  const yt_vids = [
    {
      key: '1',
      label: 'English',

      children: <iframe style={{ display: 'flex', margin: 'auto' }} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/fGweVnU99x0?si=8m1cTZ2zMiYsUDUt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    },
    // {
    //   key: '2',
    //   label: 'தமிழ்',
    //   children: <iframe style={{ display:'flex', margin:'auto'}} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/9CL7q4lB8BI?si=qku55Z__aqG98cqP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    // },
    // {
    //     key: '3',
    //     label: 'తెలుగు',
    //     children: <iframe style={{ display:'flex', margin:'auto'}} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/9CL7q4lB8BI?si=qku55Z__aqG98cqP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    // },
    {
      key: '4',
      label: 'हिंदी',
      children: <iframe style={{ display: 'flex', margin: 'auto' }} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/v2Zy8hgyaps?si=HNOuC6J-sgNoIX38" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    },
  ];


  

  useEffect(() => {

    if(props?.showPlan == undefined){
      return
    }
    setShowPlanModal(props?.showPlan)

  },[props?.showPlan])

  // Settings started

  useEffect(() => {
    if (settingsApiUpdate?.code == 200) {
      setShowSettings(false)
      message.success("Settings Updated")
    }
    if (settingsApiUpdate?.code != undefined && settingsApiUpdate?.code != 200) {
      message.error("Settings not updated")
    }

  }, [settingsApiUpdate])

  useEffect(() => {
    if (settingsPayload?.data != undefined) {

      // {"automation_setting": {"dm_automation": "true", "account_automation": "true", "comment_automation": "true"}}
      
      setInitalSettingPayload(settingsPayload?.data)
      setSettingsPayload(settingsPayload?.data)

      
        if((connectedAccounts == null || connectedAccounts == undefined || connectedAccounts?.accounts.length == 0 ) && localStorage.getItem("agency-token")){
          let apiURL = '/list-agency-account'
          
          callAPI({ url: apiURL, method: "GET", loadingState: setConnectedAccountsLoading, dataState: setConnectedAccounts, need_admin_token:true })
        }
        if(connectedAccounts?.users){
          localStorage.setItem( "connected_accounts",JSON.stringify({"accounts":connectedAccounts.users} ))
          setConnectedAccounts({"accounts":connectedAccounts.users})
        }
        else{
          return
        }
      
    }

  }, [settingsPayload])

  useEffect(() => {

    if(!connectedAccounts){
      return
    }
    if(connectedAccounts?.refresh){
      console.log("Refreshing")
      let apiURL = '/list-agency-account'
      callAPI({ url: apiURL, method: "GET", loadingState: setConnectedAccountsLoading, dataState: setConnectedAccounts, need_admin_token:true })
      return
    }
    if(connectedAccounts?.users){
      localStorage.setItem( "connected_accounts",JSON.stringify({"accounts":connectedAccounts.users} ))
      setConnectedAccounts({"accounts":connectedAccounts.users})
    }
    else{
      return
    }
  
  },[connectedAccounts])



  useEffect(() => {
    let apiURL = 'account-setting'
    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setSettingsPayload })

    
  },[])
  useEffect(() => {
    try {
      window.createLemonSqueezy()
    }
    catch (e) {

    }

  }, [])

  useEffect(() => {
    new Promise((resolve, reject) => {
      if (window.Razorpay) {
        return resolve(true);
      }

      const script = document.createElement('script');
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);  // Resolve once the script is loaded
      script.onerror = (err) => reject(new Error("Razorpay script failed to load"));

      document.body.appendChild(script);
    });
  })



  useEffect(() => {

    if(linkAccountData?.data){
      message.success("New Account Created")
      message.destroy()
      localStorage.setItem("token" ,linkAccountData?.data?.token )
      setConnectedAccounts({accounts:[...connectedAccounts.accounts, linkAccountData?.data]})
      localStorage.setItem( "connected_accounts",JSON.stringify({accounts:[...connectedAccounts.accounts, linkAccountData?.data]} ))
      setLinkAccountData({})
      setCreateLinkedAccountLoading(false)
      setCreateLinkedAccount(false)
      window.location.reload();
    }

  },[linkAccountData])

  useEffect(() => {

    if(!createLinkedAccount){
      return
    }
    message.loading("Creating new account...")
    let apiURL = '/create-agency-linked-account'
    callAPI({ url: apiURL, method: "PUT", loadingState: setCreateLinkedAccountLoading, dataState: setLinkAccountData,need_admin_token: true})
    
  }, [createLinkedAccount])



  const updateSettingsAPI = () => {
    let apiURL = `/account-setting`
    callAPI({ url: apiURL, method: "PUT", body: settingsPayload, loadingState: setupdateLoading, dataState: setSettingsApiUpdated })

  }

  const updateAutomationData = (key, value) => {


    if (key == "account_automation") {
      setSettingsPayload({
        ...settingsPayload,
        automation_setting: {
          ...settingsPayload.automation_setting,
          account_automation: value,
          dm_automation: value,
          comment_automation: value
        },
      });
      return
    }


    if (key == "plan_rate_limit") {
      setSettingsPayload({
        ...settingsPayload,
        plan_details: {
          ...settingsPayload.plan_details,
          [key]:value
        },
      });
      return
    }

    setSettingsPayload({
      ...settingsPayload,
      automation_setting: {
        ...settingsPayload.automation_setting,
        [key]: value,
      },
    });
  };

  function Avatar({ src, name }) {
    const [error, setError] = useState(false);

    return (
      <div>
        {error ? (
          <div className="avatar">{name != undefined ? name[0] : "C"}</div>
        ) : (
          <img src={src} onError={() => setError(true)} />
        )}
      </div>
    );
  }

  const [paymentLinkLoading, setPaymentLinkLoading] = useState()
  const [paymentLinkData, setPaymentLinkData] = useState({})

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

  const [updateEmail, setUpdateEmail] = useState(false)
  const [newEmail, setNewEmail] = useState()
  const [updateEmailLoading, setUpdateEmailLoading] = useState()
  const [emailIDUpdateData, setEmailIDUpdateData] = useState({})


  useEffect(() => {
    if(emailIDUpdateData?.message){
      message.destroy()
      setUpdateEmail(false)
      if(emailIDUpdateData?.code != "200"){
        message.error(emailIDUpdateData?.message)
        setEmailIDUpdateData({})
      }
      else{
        message.success(emailIDUpdateData?.message)
      confetti({
        particleCount: 400,
        spread: 150,
        origin: { y: 0.6 }
      });

        // Delay reload to allow confetti to show
        setTimeout(() => {
          localStorage.setItem("token", emailIDUpdateData.token);
          localStorage.removeItem("refCode");
          // window.location.reload();
        }, 1200);
      }

      
      
    }
  },[emailIDUpdateData])

  useEffect(() => {
    if(updateEmailLoading == true){
      message.loading("Please Wait")
    }
  },[updateEmailLoading])

  useEffect(() => {

    if(!updateEmail){
      return
    }


    let apiURL = '/update_email'
    callAPI({ url: apiURL, method: "PUT", body: {"emailid":newEmail ,

      previous_tools:  [...onboardingData?.step1, onboardingData?.step1_other],
      instagram_use: [...onboardingData?.step2, onboardingData?.step2_other],
      main_goal: onboardingData?.step3,
      other_tools: onboardingData?.step4,
      website: onboardingData?.step5,

    }, loadingState: setUpdateEmailLoading, dataState: setEmailIDUpdateData})

  },[updateEmail])

  function decodeTokenJWT(token){
        let jwt_token = jwtDecode(token)
    // console.log("JWT TOKEN", jwt_token)
    let final_data = {}
    
    if(jwt_token?.default_page?.connected_instagram_account != undefined){
      final_data = jwt_token?.default_page?.connected_instagram_account

    }
    else{
      final_data =jwt_token["default_page"]
    }

    final_data["agency"] = jwt_token?.agency
    final_data["user_id"] = jwt_token?.user_id
    final_data["name"] = jwt_token?.name
    return final_data
  }
  useEffect(() => {



    let final_data = decodeTokenJWT(token)
    setDecodeToken(final_data)
  }, [])

  useEffect(() => {

    if (paymentLinkData?.open_url) {

      window.location.href = paymentLinkData?.payment_url
      return

    }

    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ", 
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id, 
          handler: function (response) {
            setShowPlanModal(false)
            
            message.success("Payment completed, Please wait while we're verfiying!")
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            let igid = localStorage.getItem("ig_id")

            const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
            const CHAT_ID = '776956029';
            const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
            let tele_message = `[SUBSCRIBED PLAN] - user ${user_detail.emailid}  - Subscribed for  , IG ID = ${igid} , user id = ${user_detail.user_id}`
            let data = {
                chat_id: CHAT_ID,
                text: tele_message
            };


            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Message sent successfully:', data);
                })
                .catch(error => {
                    console.error('Error sending message:', error);
                });
            setPaymentLinkData({})
          },
          error: function (response) {
            // setShowPlanModal(false)
            message.error("Payment Failed, Please try again later!")
            setPaymentLinkData({})
            // setShowWaitingPaymentFailed(true)
            // alert("Payment Failed: " + response.error.description);
          },
          modal: {
            ondismiss: function () {
              message.error("Payment Cancelled, Please try again!")
              setPaymentLinkData({})
            }
          },
          prefill: {
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  const handleLogout = () => {
    // Clear all localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key !== "previous_config") {
          localStorage.removeItem(key);
      }
  });
    // Redirect to the login page
    window.location.href = '/login';
  };

  const { Step } = Steps;

const [currentStep, setCurrentStep] = useState(-1);
const [onboardingData, setOnboardingData] = useState({
  step1: undefined,
  step2: undefined,
  step3: undefined,
  step4: undefined,
  step5: undefined,
});

  const onboardingSteps = [
  {
    // title: 'Previous Tools',
    
    content: (
      <div>
      <h3>Have you used any of these tools before?</h3>
      <Checkbox.Group
        size="large"
        style={{ width: "100%" ,marginTop: "20px" , display: "flex", flexDirection: "column" , gap:"8px"}}
        value={onboardingData.step1}
        onChange={value => setOnboardingData(prev => ({ ...prev, step1: value }))}
        placeholder="Have you used any of these tools before?"
        options={[
          { label: "Manychat", value: "manychat" },
          { label: "Linkdm", value: "linkdm" },
          { label: "Zorcha", value: "zorcha" },
          { label: "Super Profile", value: "superprofile" },
          { label: "Inro", value: "inro" },
          
          { label: "Nothing", value: "none" },
          { label: "Other", value: "other" },
        ]}
      />
         {onboardingData.step1?.includes("other") && (
        <Input
          style={{ marginTop: 12 }}
          placeholder="Please specify other tool(s)"
          value={onboardingData.step1_other || ""}
          onChange={e =>
            setOnboardingData(prev => ({ ...prev, step1_other: e.target.value }))
          }
        />
      )}
      </div>
    ),
  },
  {
    // title: 'Instagram Use',
    
    content: (
      <div>
      <h3>What suits you best?</h3>
      <Checkbox.Group
        style={{ width: "100%", marginTop: "20px" , display: "flex", flexDirection: "column" , gap:"8px"}}        value={onboardingData.step2}
        onChange={value => setOnboardingData(prev => ({ ...prev, step2: value }))}
        placeholder="What do you use Instagram for?"
        options={[
          { label: "Content Creator", value: "creator" },
          { label: "E-commerce", value: "business" },
          { label: "Agency / Afilliate Marketing", value: "agency" },
          { label: "Other", value: "other" }
        ]}
      />
      {onboardingData.step2?.includes("other") && (
        <Input
          style={{ marginTop: 12 }}
          placeholder="Please specify"
          value={onboardingData.step2_other || ""}
          onChange={e =>
            setOnboardingData(prev => ({ ...prev, step2_other: e.target.value }))
          }
        />
      )}
      </div>
    ),
  },
  {
    // title: 'Main Goal',
    content: (
      <div>

      <h3>What is your main goal with InstantDM?</h3>
      <Checkbox.Group

        style={{ width: "100%", marginTop: "20px", display: "flex", flexDirection: "column" , gap:"8px"}}
        value={onboardingData.step3}
        onChange={value => setOnboardingData(prev => ({ ...prev, step3: value }))}
        placeholder="Your main goal with InstantDM"
        options={[
          { label: "Increase product sales", value: "sales" },
          { label: "Get more leads", value: "leads" },
          { label: "Grow my followers", value: "followers" },
          { label: "Engage with my audience", value: "engagement" }
        ]}
      />
      </div>
    ),
  },
  {
    // title: 'Other Tools',
    question : "Are you using any of these tools currently?",
    content: (
      <div>
      <h3>Are you using any of these tools currently?</h3>
      <Checkbox.Group
        style={{ width: "100%", marginTop: "20px" , display: "flex", flexDirection: "column" , gap:"8px"}}
        value={onboardingData.step4}
        onChange={value => setOnboardingData(prev => ({ ...prev, step4: value }))}
        placeholder="Are you using any of these tools currently?"
        options={[
          { label: "Shopify", value: "shopify" },
          { label: "Open in App", value: "open_in_app" },
          { label: "Link.ID", value: "link_id" },
          { label: "Super Profile", value: "superprofile" },
          { label: "Link Tree", value: "linktree" },
          { label: "Bento", value: "bento" },
          { label: "Wordpress / Woo-Commerce", value: "wordpress" },
          { label: "Nothing", value: "none" } 
        ]}
      />
      </div>
    ),
  },
   {
    // title: 'Website',
    question : "Do you have a website?",
    content: (
      <div>
      <h3>Do you have a website?</h3>
      <Input
        prefix={<GlobalOutlined />}
        value={onboardingData.step5 || ""}
        onChange={(e) => setOnboardingData(prev => ({ ...prev, step5: e.target.value }))}
        placeholder='Please share your website link'
        style={{ marginTop: "20px" }}
      />
      </div>
    ),
  },
  {
    // title: 'Email',
    content: (
      <div>
      <h3>Do you have an email ID?</h3>
      <Input
        prefix={<MailOutlined />}
        value={newEmail}
        onChange={(e) => setNewEmail(e.target.value)}
        placeholder='Please provide your Email ID'
        style={{ marginTop: "20px" }}
      />
      </div>
    ),
  },
];



  return (

    <div>
      {contextHolder}
      <div style={{position:"fixed", top:0, left:0, width:"100%", zIndex:1000}}>
          {settingsPayload?.connected_accounts?.fb_data?.error &&  <Alert
                message="Facebook conection expired! Automation Stopped."
                showIcon
                description="Reconnect your facebook page to use the automation features."
                type="error"
                action={
                  <a href="/ig-connect"><Button danger>Connect Instagram via FB Page</Button></a>
                }
            />}

            {settingsPayload?.connected_accounts?.ig_data?.error && <Alert
                message="Instagram conection expired! Automation Stopped."
                showIcon
                description="Reconnect your Instagram account to use."
                type="error"
                action={
                  <a href="/ig-connect?show_ig_connect=true"><Button danger>Connect Instagram Directly</Button></a>
                }
              />}
      </div>
      <div className='mobile-nav'>
        <div style={{ flex:1  }}>
          <Link to='/'>
          <div style={{ display: 'flex', gap:"4px", flexDirection: 'row', alignItems: 'center', marginLeft: '0' }}> 
            <img
            src="/logo192.png"
            alt="InstantDM Logo"
            style={{ width: 32, height: 32, marginBottom: 8 , marginLeft: '10px'}}
          />
          <h3 className='logo-tex'>instantDM</h3>
          </div>

          </Link>
        </div>

        <div onClick={() => { setShowPlanModal(true) }} className='feedback' style={{ marginLeft: '10px' }}>
          <h6 style={{ fontSize: '16px', color: 'black', padding: '10px' }}><CrownOutlined /></h6>
        </div>
        {/* <div onClick={() => { createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData) }} className='feedback' style={{ marginLeft: '0px' }}>
          <h6 style={{ fontSize: '16px', color: 'black', padding: '10px' }}><FireOutlined /></h6>
        </div> */}

        {/* <p>@{decodedToken?.username}</p> */}
        
        <div style={{ marginLeft: '0px' }}>
          <Link to='/referral-dashboard' className={location.pathname === '/referral-dashboard' ? 'feedback active' : 'feedback'}><DollarOutlined /></Link>
        </div>
        <div onClick={() => { setShowVideo(true) }} className='feedback' style={{ marginLeft: '0px' }}>
          <h6 style={{ fontSize: '16px',  padding: '10px' }}><VideoCameraOutlined /></h6>
        </div>
        <div onClick={() => { setShowReconnect(true) }} className='feedback' style={{ marginLeft: '0px', marginRight: '0px' }}>
          <h6 style={{ fontSize: '16px', color: 'red', padding: '10px' }}><ExclamationCircleOutlined /></h6>
        </div>
        <div onClick={() => { setShowSettings(true) }} className='feedback' style={{ marginLeft: '0px', marginRight: '20px' }}>
          <h6 style={{ fontSize: '16px', padding: '10px' }}><SettingOutlined /></h6>
        </div>
     
        {
          ["/" ,"/dashboard", "/home", "/oia","/yt","/referral-dashboard"].includes(location.pathname ) && <div className='float-menu-mob mobile'>
          <Link to='/dashboard' className={location.pathname === '/' ? 'active' : ''}><BarChartOutlined /></Link>
          <Link to='/home' className={['/home',"/"].includes(location.pathname) ? 'active' : ''}><CommentOutlined /></Link>
          <Link to='/oia' className={location.pathname === '/oia' ? 'active' : ''} ><LinkOutlined /></Link>
          <Link to='/yt' className={location.pathname === '/YT' ? 'active' : ''} ><ShopOutlined /></Link>
          {/* <Link to='/yt' className={location.pathname === '/yt' ? 'active' : ''} ><YoutubeOutlined />YT</Link> */}
          {(decodedToken?.agency || decodedToken?.agency_id || localStorage.getItem("agency-token") ) &&  <Popover placement='top' content={
                  <div style={{maxHeight:"400px", display:"flex" , flexDirection:"column", overflow:"scroll"}}>
              
              {
                (connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length > 0) && connectedAccounts.accounts.map( (account, index) =>(
                  <div onClick={() => {
                    localStorage.setItem("token" ,account.token )
                    localStorage.setItem("userData" , JSON.stringify(decodeTokenJWT(account.token)))
                    window.location.reload();
                  }} style={{display:"flex", flexDirection:"row", gap:"10px", alignItems:"center"}}>
                  <img style={{height:"40px", width:"40px", borderRadius:'100px'}} key={index} alt={index} src={account?.default_page?.profile_picture_url  || default_img}/>
                  
                  <p>@{account?.default_page?.username || "Empty"} {(decodedToken?.user_id  == account?.user_id) && <CheckCircleTwoTone style={{color:"green"}}/> }</p>
                  </div>
                  
                ))
              }

             { (connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length < 20 ) &&  <div onClick={() => setCreateLinkedAccount(true)} style={{display:"flex", flexDirection:"row", gap:"10px", alignItems:"center"}}>
              <PlusCircleOutlined style={{fontSize:"24px", color:"green", cursor:"pointer"}}  />
              <p>Add new account</p>
              </div>
            }


              <div onClick={() => {
              localStorage.removeItem("connected_accounts")
              setConnectedAccounts({"refresh":true,"accounts":[]})

            }} style={{display:"flex", flexDirection:"row", gap:"10px", alignItems:"center"}}>
              <ReloadOutlined style={{fontSize:"14px",cursor:"pointer"}}  />
              <p>Refresh Accounts</p>
              </div>

              
              
              </div>
                } >
          <div style={{display:"flex", flexDirection:"row", alignContent:"center", alignItems:"center"}}><img src={`https://imagecorsworkers.sanjayhotaction.workers.dev/${decodedToken?.profile_picture_url}`} style={{height:'30px', width:'30px', borderRadius:'100px'}} /> </div>
          </Popover>
        }
        </div>
        }
        

      </div>

      <div className="sidebar">

        <div>
        <Link to='/'>
          <div style={{ display: 'flex', gap:"20px", flexDirection: 'row', alignItems: 'center', marginLeft: '0' }}> 
            <img
            src="/logo192.png"
            alt="InstantDM Logo"
            style={{ width: 52, height: 52,  marginLeft: '10px', marginTop:"10px"}}
          />
          <h3 className='logo-tex'>instantDM</h3>
          </div>
        </Link>
        <div className='menu-options'>
        <Link to='/dashboard' ><h6 className={location.pathname === '/dashboard' ? 'active' : ''}><BarChartOutlined className='mo-icon'  />Dashboard</h6></Link>
        <Link to='/home' ><h6 className={['/home',"/"].includes(location.pathname) ? 'active' : ''}><CommentOutlined className='mo-icon'  />Instant DM</h6></Link>
        <Link to='/oia'  ><h6 className={location.pathname === '/oia' ? 'active' : ''}><LinkOutlined className='mo-icon'  />Instant Open</h6></Link>
        <Link to='/yt' ><h6  className={location.pathname === '/yt' ? 'active' : ''}><ShopOutlined className='mo-icon'  />Instant Sell</h6></Link>
        <div onClick={() => { setShowPlanModal(true) }}>
          <h6> <CrownOutlined className='mo-icon' />My Plan</h6>
        </div>
        <Link to='/referral-dashboard' ><h6 className={location.pathname === '/referral-dashboard' ? 'active' : ''}><DollarOutlined className='mo-icon'  />Affiliate & Referral</h6></Link>
        
        <div onClick={() => { setShowReconnect(true) }} >
          <h6 > <ExclamationCircleOutlined className='mo-icon' />Automation Not working?</h6>
        </div>
        <div onClick={() => { setShowVideo(true) }} >
          <h6 ><VideoCameraOutlined className='mo-icon' />Watch Video</h6>
        </div>
        <div onClick={() => { setShowSettings(true) }} >
          <h6 ><SettingOutlined className='mo-icon' />Account Settings</h6>
        </div>
        <div onClick={() => { setOpen(true) }}>
          <h6> <MessageOutlined className='mo-icon' /> Have feedback?</h6>
        </div>

        </div>
        </div>

        <div>

            {(decodedToken?.agency || decodedToken?.agency_id  || localStorage.getItem("agency-token")) && 
            <div className='switch-accounts'>
            {(connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length < 20 ) && <Tooltip title='Add new account'>
              <PlusCircleOutlined onClick={() => setCreateLinkedAccount(true)} style={{fontSize:"24px", color:"green", cursor:"pointer"}}  />
              </Tooltip>
              }
              {
                (connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length > 0) && connectedAccounts.accounts.map( (account, index) =>(
                  <Popover placement='top' content={
                    <div style={{display:"flex" , flexDirection:"column"}}>
                      <img key={index} src={account?.default_page?.profile_picture_url  || default_img} style={{width:'100px', height:"100px", borderRadius:"10px"}} />
                      <a href={`https://instagram.com/${account?.default_page?.username}`}>@{account?.default_page?.username || "Not Connected"}</a>
                    </div>
                  } >
                  {/* <img key={index} alt={index} src={account?.default_page?.profile_picture_url} onClick={() => {
                    localStorage.setItem("token" ,account.token )
                    window.location.reload();
                  }}/> */}
                  <div style={{ position: 'relative' }}>
                      <img 
                        key={index} 
                        alt={index} 
                        src={account?.default_page?.profile_picture_url || default_img} 
                        onClick={() => {
                          localStorage.setItem("token", account.token)
                          localStorage.setItem("userData" , JSON.stringify(decodeTokenJWT(account.token)))
                          window.location.reload();
                        }}
                      />
                      {(decodedToken?.user_id  == account?.user_id) && 
                        <CheckCircleTwoTone style={{
                          position: 'absolute', 
                          top: 0, 
                          right: 0, 
                          // color: 'white'
                        }}/>
                      }
                    </div>
                  </Popover>
                ))
              }
            <Tooltip title='Reload connected accounts.'>
              <ReloadOutlined 
              
              onClick={() => {
                localStorage.removeItem("connected_accounts")
                setConnectedAccounts({"refresh":true,"accounts":[]})
              }}
              style={{fontSize:"14px", color:"grey", opacity:".8", cursor:"pointer"}}  />
              </Tooltip>
            
            </div>
            }

          <div className='insta-card insta-card-side'>
          <Avatar src={decodedToken?.profile_picture_url} name={decodedToken?.name} />
          <div>
            <Tooltip title={decodedToken?.name ||  decodedToken?.username || "Connect IG"}> 
              <h3>{decodedToken?.username  || decodedToken?.username || "Connect IG"}</h3>
            </Tooltip>
            </div>
          </div>

        </div>


      </div>



        <Modal
          title="Product Guide"
          open={showVideo}
          width={800}
          height={600}
          onOk={() => {
            setShowVideo(false)
          }}

          onCancel={() => { setShowVideo(false) }}
        >
          <Tabs defaultActiveKey="1" items={yt_vids} />

        </Modal>

        <Modal
          title="Submit your Feedback"
          open={open}
          onOk={() => {


            setOpen(false)

            // messageApi.open({
            //     key:"1",
            //     type: 'success',
            //     content: 'Thanks for the feedback!',
            //   });
          }}
          // okText = "Submit my feedback"
          confirmLoading={confirmLoading}
          onCancel={() => { setOpen(false) }}
        >
          <p>Hii There, thanks for taking a moment to share feedback. It will really help us to improve our service and product a lot.</p>
          <a target='_blank' href='https://www.instagram.com/code_with_ssk'>Send a DM in instagram - Code with SSK</a>
          <p>or you can send email to <span style={{ color: 'blue' }}>ssk@instantdm.com</span></p>
          {/* <TextArea value={feedbacktext} onChange={(e) => setFeedbackText(e.target.value)} rows={8} placeholder="Please share your feedback here." /> */}

        </Modal>

        <Modal
          title="Automation not working?"
          open={showReconnect}
          confirmLoading={confirmLoading}
          onCancel={() => { setShowReconnect(false) }}
        >

          <div className='Connected Accounts'>

              {settingsPayload?.connected_accounts?.fb_data?.error &&     <Alert
                  message="Facebook conection expired"
                  showIcon
                  description="Reconnect your facebook page to use the automation features."
                  type="error"
                  action={
                    <a href="/ig-connect"><Button danger>Connect Instagram via FB Page</Button></a>
                  }
                />}

              {settingsPayload?.connected_accounts?.ig_data?.error && <Alert
                  message="Instagram conection expired"
                  showIcon
                  description="Reconnect your Instagram account to use."
                  type="error"
                  action={
                    <a href="/ig-connect?show_ig_connect=true"><Button danger>Connect Instagram Directly</Button></a>
                  }
                />}

          </div>

            <Divider />
            <div style={{display:'flex' , flexDirection:'column',  gap:'20px', marginTop:'40px'}}>
            <a href="/ig-connect?show_ig_connect=true"><Button danger>Connect Instagram Directly</Button></a>
            <a href="/ig-connect"><Button danger>Connect Instagram via FB Page</Button></a>
            <Divider/>
            </div>
            
            <Collapse items={[
              {key: '1',
              label: 'More options!',
              children:
              <div style={{display:'flex' , flexDirection:'column', marginTop:'10px', gap:'20px', marginBottom:'40px'}}>
              <h3>Please Select your issue</h3>
              <Button danger><a href="/ig-connect">Reels, Posts Comment DM not working?</a></Button>
              <Button danger><a href="/ig-connect?show_ig_connect=true">Story DM not working?</a></Button>
              <Button danger><a href="/ig-connect?show_ig_connect=true">Followers only DM not working?</a></Button>
            </div>
              }]}/>
              <Divider/>

            
          {/* <div style={{ marginBottom: '20px', display: "flex", flexDirection: "row", alignContent: 'flex-start', alignItems: 'center', justifyContent: "space-between" }}>
            Regular post comment automation not working
            <Button type="primary" danger><a href="/ig-connect">Reconnect Instagram via FB</a></Button>
          </div>
          <div style={{ marginBottom: '20px', display: "flex", flexDirection: "row", alignContent: 'flex-start', alignItems: 'center', justifyContent: "space-between" }}>
            <p>Boosted post comment automation not working</p>
            <Button danger><a href="/ig-connect?show_ig_connect=true">Reconnect with Instagram</a></Button>
          </div> */}

          <Collapse items={[
            {
              key: '1',
              label: 'Not working after reconnected?',
              children: <p>Please reach out via instagram <a href='https://instagram.com/code_with_ssk' target='_blank'>@code_with_ssk</a> or mail us at ssk@instantdm.com</p>,
            },
          ]} />
        </Modal>

        <Modal
        closable={false}
          title={
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>Settings</span>
              <div style={{ display: "flex", gap:'10px' }}>
                <Button onClick={() => { setSettingsPayload(initialSettingPayload); setShowSettings(false); }}>Cancel</Button>
                <Button type="primary" loading={updateLoading} onClick={updateSettingsAPI}>
                  Save Settings
                </Button>
              </div>
            </div>
          }
          open={showSettings}
          footer={null} // Hide default footer
        >
        { settingsPayload?.automation_setting != undefined && 
          <>
          <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>Instagram Saftey Settings</h3>
              <p style={{ marginTop: '0px', fontSize: '12px' }}>Configure your Instagram account saftey settings.</p>


   
                <div className='setting-item'>
                <div className='row'>
                  <h3> Facebook Page <Tag color={settingsPayload?.connected_accounts?.fb_data?.id != undefined ? "green" : "red"}>{settingsPayload?.connected_accounts?.fb_data?.id != undefined ? "Connected" : "Not Connected"}</Tag></h3>
                  <Button href="/ig-connect"  >
                    {settingsPayload?.connected_accounts?.fb_data?.id != undefined ? "Re-Connect FB Page" : "Connect FB Page"}
                  </Button>
                </div>
                <p>Connect Facebook page for better comment delivery ratio and advanced account saftey. InstantDM will distribute automation between your IG account and FB Page. This will keep your account under radar from instagram automation detection.</p>
                
              </div>


              <div className='setting-item'>
               

                <div className='row'>
                  <h3>New Automation Per Hour</h3>
                  <Select style={{width:"170px"}} 
                  
                  onChange={(value) => updateAutomationData('plan_rate_limit', value)}
                  defaultValue={Number(settingsPayload.plan_details?.plan_rate_limit ?? (["428338", "428337"].includes(settingsPayload.plan_details?.id) ? 1500 : 800))}


                  options={[
                    {
                      "label":"500 Automation",
                      "value":500,
                    },
                    {
                      "label":"800 Automation",
                      "value":800,
                      disabled: !["428338", "428337","000003", "0000031"].includes(settingsPayload.plan_details?.id)
                    },
                    {
                      "label":"1500 Automation",
                      "value":1500,
                      disabled: !["428338", "428337","000003", "0000031"].includes(settingsPayload.plan_details?.id)
                    },
                    {
                      "label":"2000 Automation",
                      "value":2000,
                      disabled: !["428338", "428337"].includes(settingsPayload.plan_details?.id)
                    },
                    {
                      "label":"2500 Automation",
                      "value":2500,
                      disabled: !["428338", "428337"].includes(settingsPayload.plan_details?.id)
                    },
                    {
                      "label":"3000 Automation",
                      "value":3000,
                      disabled: !["428338", "428337"].includes(settingsPayload.plan_details?.id)
                    },
                    {
                      "label":"Maximum Allowed",
                      "value":20000,
                      disabled: !["428338", "428337"].includes(settingsPayload.plan_details?.id)
                    },
                  ]} />
                  
                </div>
                <p>No.of new comment to DM automation per hour.</p>
              </div>

              <div className='setting-item'>
                <div className='row'>
                  <h3>Rate Limit Retry</h3>
                  <Slider                    
                    min={1}
                    max={120}
                    defaultValue={settingsPayload.automation_setting.rate_limit_retry || 60}
                    onChange={(value) => {updateAutomationData('rate_limit_retry', value)}}
                    style={{width:'150px'}}
                    tooltip={{
                      formatter: (value) => SliderFormat(value)
                    }}
                  />
                </div>
                <p>Retry duration after you have reached instagram rate limit. Recommended to keep 30 - 60 minutes for maximum account saftey.</p>
                <p>Currently set to {SliderFormat(settingsPayload.automation_setting.rate_limit_retry || 60)}</p>
              </div>

          <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>Account Automation settings</h3>
          <p style={{ marginTop: '0px', fontSize: '12px' }}>Configure your account level automation</p>
              <div className='setting-item'>
                
                <div className='row'>
                  <h3 >Global Automations</h3>
                  <Radio.Group onChange={(e) => updateAutomationData('account_automation', e.target.value)} defaultValue={settingsPayload.automation_setting.account_automation}>
                    <Radio.Button value="true">Enabled</Radio.Button>
                    <Radio.Button value="false">Disabled</Radio.Button>
                  </Radio.Group>
                </div>
                <p>Your account level automation, if you disabled it no automations will work.</p>
              </div>
              <div className='setting-item'>
                <div className='row'>
                  <h3>Comment Replies</h3>
                  <Tooltip title={settingsPayload.automation_setting.account_automation == "false" ? "Please enable account level automation" : ""}>
                    <Radio.Group onChange={(e) => updateAutomationData('comment_automation', e.target.value)} disabled={settingsPayload.automation_setting.account_automation == "false" ? true : false} value={settingsPayload.automation_setting.comment_automation}>
                      <Radio.Button value="true">Enabled</Radio.Button>
                      <Radio.Button value="false">Disabled</Radio.Button>
                    </Radio.Group>
                  </Tooltip>
                </div>
                <p>Your account level comment automation, if you disabled it no comment automations will work.</p>
              </div>
              <div className='setting-item'>
                <div className='row'>
                  <h3>DM Automations</h3>
                  <Tooltip title={settingsPayload.automation_setting.account_automation == "false" ? "Please enable account level automation" : ""}>
                    <Radio.Group onChange={(e) => updateAutomationData('dm_automation', e.target.value)} disabled={settingsPayload.automation_setting.account_automation == "false" ? true : false} value={settingsPayload.automation_setting.dm_automation}>
                      <Radio.Button value="true">Enabled</Radio.Button>
                      <Radio.Button value="false">Disabled</Radio.Button>
                    </Radio.Group>
                  </Tooltip>
                </div>
                <p>Your account level DM automation, if you disabled it no DM automations will work.</p>
              </div>

              <div className='setting-item'>
                  <h3>Account Setting</h3>
                  <p>{settingsPayload.token_data.emailid}</p>
              </div>

              {/* <div className='setting-item'>
                <div className='row'>
                  <h3>Trending Mode - Cool Off</h3>
                  <Tooltip title={"Cool off period for your account before activating viral mode."}>
                    
                  <Slider
                    min={5}
                    max={180}
                    step={5}
                    defaultValue={settingsPayload.automation_setting.treding_cool_off_waiting || 60}
                    onChange={(value) => {updateAutomationData('treding_cool_off_waiting', value)}}
                    style={{width:'150px'}}
                    tooltip={{SliderFormat}}
                  />

                  </Tooltip>
                </div>
                <p>Cool-Off period is set to {settingsPayload.automation_setting.treding_cool_off_waiting || 60 } Minutes.</p>
              </div> */}

              
          

            </>
          }
          
            <Button danger onClick={handleLogout}>Logout</Button>
        </Modal>

        <Modal
          title="Plans"
          open={showPlanModal}
          onCancel={() => {setShowPlanModal(false); 
            if (props?.setShowPlan != undefined){
              props.setShowPlan(false)
            }}}
          footer={null}
          style={{ top: 0 }}
          width='100%'
          height={"100%"}
          // style={{ maxWidth: '1200px' }}
        >


          <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
        </Modal>
          
        <Modal
          title="Create new client account!"
          open={showCreateAccount}
          width={800}
          height={600}
          onOk={() => {
            setShowCreateAccount(false)
          }}
          onCancel={() => { setShowCreateAccount(false) }}
        >

          

        </Modal>
        
    <Modal closable={false} 
        
       footer={ !emailIDUpdateData?.activated && [
      currentStep > 0 && <Button
      key="back"
      onClick={() => setCurrentStep(currentStep - 1)}
      disabled={currentStep === 0}
      style={{ marginRight: 8 }}
    >
      Previous
    </Button> ,
    currentStep < onboardingSteps.length - 1 ? (
      <Button
        key="next"
        type="primary"
        onClick={() => setCurrentStep(currentStep + 1)}
        disabled={
          (currentStep === 0 && !onboardingData.step1    ) ||
          (currentStep === 1 && !onboardingData.step2    ) ||
          (currentStep === 2 && !onboardingData.step3     ) ||
          (currentStep === 3 && !onboardingData.step4    ) 
          // (currentStep === 4 && !onboardingData.step5    ) 
        }
      >
        {currentStep === 4 && onboardingData.step5 == undefined   ?  "Skip" : currentStep == -1 ? "Setup Account" : "Next"}
      </Button>
    ) : (
      <Button
        key="submit"
        type="primary"
        loading={updateEmailLoading}
        disabled={
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)
          
        }
        onClick={() => {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!regex.test(newEmail)) {
            message.error("Please enter valid email");
          } else {
            setUpdateEmail(true);
          }
        }}
      >
        Create Account
      </Button>
    ),
        ]}

        // bodyStyle={{ background: "#f7f8fa" }} 
        open={settingsPayload?.not_activated}
        title={currentStep == -1 ? "Welcome to InstantDM" : "Setup your InstantDM account"}>
          
        {/* <Steps current={currentStep}

        size="small" style={{ margin: "20px 0" }} items = {onboardingSteps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))} /> */}
        
        { currentStep == -1 && 
        
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "24px",
            minHeight: "320px",
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
            padding: "32px 24px",
          }}
        >
          <img
            src="/logo192.png"
            alt="InstantDM Logo"
            style={{ width: 64, height: 64, marginBottom: 8 }}
          />
          <h2 style={{ margin: 0, color: "#222", fontWeight: 700 }}>Welcome to InstantDM!</h2>
          <Alert type='success'message= "Meta Verified Instagram DM automation tool" />
            
            <div className="insta-card insta-card-side" style={{ backgroundColor: "#f7f8fa", borderRadius: 12, padding: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }}>
            <Avatar src={decodedToken?.profile_picture_url} name={decodedToken?.name} />
            <div>
              <h3 style={{ color: "#222", margin: 0 , fontSize:"22px"}}>{decodedToken?.username || "Connect IG"}</h3>
            </div>
          </div>
          <p style={{ color: "#666", margin: 0, fontSize: 16, textAlign: "center" }}>
            Let's get you started with a quick onboarding!
          </p>
        </div>
        
        }


        { (currentStep > -1 && !emailIDUpdateData?.activated ) && <div
        style={{padding:"10px"}}
        >{onboardingSteps[currentStep].content}</div> }


        {
  emailIDUpdateData?.activated && (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
      minHeight: "220px"
    }}>
      <h3>Welcome to InstantDM, {decodedToken?.username || "User"}!</h3>
      <p>Your account is now activated. You can start using InstantDM to automate your Instagram.</p>
      <div
        style={{
          background: "#f7f8fa",
          borderRadius: 12,
          padding: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
          marginBottom: 12,
          textAlign: "center"
        }}
      >
        <p style={{ color: "#333", marginBottom: 12 }}>
          <b>Tip:</b> Connect your Facebook Page for better comment delivery ratio and to keep your account more safer.
        </p>
        
        <Button
          type="default"
          onClick={() => {window.location.reload();}}
        >
          I'll do it later
        </Button>
        <Button
          type="primary"
          href="/ig-connect"
          style={{ marginRight: 8 }}
        >
          Connect Facebook Page
        </Button>
      </div>
    </div>
  )
}
          
        </Modal>

    </div>)

}
export default Sider;